import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, Glyphicon } from '@bingads-webui-react/primitive';

export default class ButtonAction extends PureComponent {
  static defaultProps = {
    disabled: false,
  }

  render() {
    const {
      value,
      selected,
      onClick,
      disabled,
      actionLabel,
    } = this.props;
    const ariaLabel = `${actionLabel} ${value}`;

    return (
      <Button
        className="button-action"
        onClick={() => onClick(value)}
        disabled={disabled}
        aria-label={ariaLabel}
      >
        <Glyphicon glyph={selected ? 'chevron-left' : 'chevron-right'} />
      </Button>
    );
  }
}

ButtonAction.propTypes = {
  value: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  actionLabel: PropTypes.string.isRequired,
};
